import Icon from 'components/Icon';
import { FireTaskStatus, FireTaskType } from 'models/FireTaskModel';
import React from 'react';
import { FormattedMessage } from 'react-intl';

interface FireProgressComponentProps {
  stepsAndStatus: {
    step: FireTaskType;
    status?: FireTaskStatus;
    current_completion?: number;
    target_completion?: number;
  }[];
  retryTasks: () => void;
}

const FireProgressComponent: React.FC<FireProgressComponentProps> = ({
  stepsAndStatus,
  retryTasks
}) => {
  return (
    <ul className="fire-progress-component">
      {stepsAndStatus.map((stepAndStatus, index) => (
        <li
          key={`${stepAndStatus.step}-${index}`}
          className="fire-progress-component__item"
        >
          {index !== stepsAndStatus.length - 1 && (
            <span className="fire-progress-component__vertical-line" />
          )}
          {stepAndStatus.status === 'failed' ? (
            <div className="fire-progress-component__circle fire-progress-component__circle--failed">
              <Icon name="cross" />
            </div>
          ) : stepAndStatus.status === 'running' ? (
            <div className="fire-progress-component__circle fire-progress-component__circle--running">
              <svg
                className="loading__icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 138 58"
              >
                <path
                  className="loading__path"
                  strokeLinecap="round"
                  pathLength="1"
                  fill="none"
                  strokeWidth="15"
                  d="M44 9a25 25 0 100 40c2.8-2 19.5-15.4 50-40a25 25 0 110 40c-2.8-2-32.2-26.7-50-40z"
                />
              </svg>
            </div>
          ) : stepAndStatus.status === 'done' ? (
            <div className="fire-progress-component__circle fire-progress-component__circle--done">
              <Icon name="check" />
            </div>
          ) : (
            <div className="fire-progress-component__circle fire-progress-component__circle--pending">
              <Icon name="pending" />
            </div>
          )}
          <span className="fire-progress-component__text">
            <FormattedMessage id={`fire_task_${stepAndStatus.step}`} />{' '}
            ({stepAndStatus.current_completion} von {stepAndStatus.target_completion})
          </span>
        </li>
      ))}
      {stepsAndStatus.some(
        (stepAndStatus) => stepAndStatus.status === 'failed'
      ) && (
        <button className="fire-progress-component__retry-button"
          onClick={() => {
            retryTasks();
          }}
        >
          <FormattedMessage id="fire task retry" />
        </button>
      )}
    </ul>
  );
};

export default FireProgressComponent;
